/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Lightbox-related functions
//
// This builds on top of fancybox, providing some compatibility with the old code
//
// NOTE: This file uses require() (CommonJS) rather than ES `import` on purpose.
// Webpack treats any file containing an `import` statement as an ES module, which
// disables runtime `module.exports.X = Y` assignments. The IIFE below assigns
// `openIbox`, `hideIbox`, and `default_fancybox_options` onto `module.exports` so
// that `expose-loader` can pick them up and bind them as window globals (see
// app/javascript/application.js). Switching to `import` here silently breaks
// every consumer of `window.openIbox` / `window.hideIbox`.
const Cookies = require('js-cookie');
const FocusTrap = require('../../../javascript/utils/modal-focus-trap').default;

namespace('Slzr.Lightbox', function(exports, top) {
  let $;
  const jQuery = ($ = Slzr.jQuery);

  // Default fancybox options
  exports.default_fancybox_options = {
    overlayColor: '#111',
    padding: 0
  };
  //  centerOnScroll: false

  // Expose fancybox options as global variable
  top.default_fancybox_options = exports.default_fancybox_options;

  let previousActiveElement = null;

  // Display a lightbox
  exports.open = function(params) {
    // Triggering element
    let $element;
    if (params == null) { params = {}; }
    const {
      element
    } = params;
    if (element) { $element = jQuery(element); }

    let focusTrapped = false;

    const options = Slzr.jQuery.extend({}, default_fancybox_options, params, {
      onStart() {
        return (typeof params.onStart === 'function' ? params.onStart() : undefined);
      },

      onClosed() {
        // Trigger lightbox closed event on the link
        if ($element != null) {
          $element.trigger('slzr:lightbox-closed');
        }

        // Disable focus trapping
        if (focusTrapped) { FocusTrap.untrap(); }

        // Restore focus to the previous element, if set
        if (previousActiveElement != null) {
          previousActiveElement.focus();
        }
        previousActiveElement = null;

        // Trigger ajax complete event to restore the disable-with state of the opening element (if any).
        //
        // TODO: Revamp login lightbox without need for this
        if ($element != null ? $element.data('ujs:enable-with') : undefined) { if ($element != null) {
          $element.trigger('ajax:complete');
        } }

        return (typeof params.onClosed === 'function' ? params.onClosed() : undefined);
      },

      onComplete() {
        let post_login_action = params.postLoginAction || ($element != null ? $element.data('post-login-action') : undefined);
        if ((post_login_action === '') || (post_login_action === '#')) { post_login_action = null; }

        // Update lightbox contents with the post login action, if specified
        if (post_login_action) {
          // Any previous_url form elements
          $('#fancybox-content [name=previous_url]').val(post_login_action);

          // Handle encoded shibboleth URLs
          const encoded_url = encodeURIComponent(post_login_action);
          $('#fancybox-content')[0].innerHTML = $('#fancybox-content')[0].innerHTML.replace(/(previous_url=)[^&"]*([&"])/g, `$1${  encoded_url  }$2`);
        }

        // Store the previously focused element
        previousActiveElement = document.activeElement;

        // Try to focus the first visible element
        FocusTrap.focusFirstDescendant($('#fancybox-content').get(0));

        // Enable focus trapping within the lightbox, unless it's explicitly disabled via data-disable-focus-trap
        if (!($element != null ? $element.is('[data-disable-focus-trap]') : undefined)) {
          FocusTrap.trap(document.getElementById('fancybox-outer'));
          focusTrapped = true;
        }

        // Trigger a lightbox opened event on the link
        if ($element != null) {
          $element.trigger('slzr:lightbox-opened');
        }

        return (typeof params.onComplete === 'function' ? params.onComplete() : undefined);
      }
    }
    );

    return jQuery.fancybox(options);
  };

  exports.close = () => jQuery.fancybox.close();

  // Opens a lightbox with the specified URL
  //
  // If URL starts with a #, will assume it is the ID of a dom element to display,
  // otherwise will do an AJAX style request
  const openIbox = function(url, params) {
    let content; let href; let imgAltText; let type;
    if (params == null) { params = {}; }
    if (url.substr(0, 1) === '#') {
      // Element (inline)
      type = 'inline';
      href = url;
    } else if (url.match(/^\//) || url.match(/^https?\:/)) {
      // Ajax anything starting with http or a /
      href = url;
      type = url.match(/\.(png|jpg|jpeg|gif)/i) ? 'image' : 'ajax';
    } else {
      content = url;
      href = null;
      type = null;
    }

    const options = Slzr.jQuery.extend({}, default_fancybox_options, {
      type,
      onComplete: params.onComplete,
      onClosed: params.onClosed,
      onStart: params.onStart,
      element: params.element,
      event: params.event,
      postLoginAction: params.postLoginAction
    }
    );

    if (href != null) { options.href = href; }
    if (content != null) { options.content = content; }
    
    if (type === 'image') { imgAltText = __guard__(params.element.querySelector('img'), x => x.alt); }
    if (imgAltText != null) { options.title = imgAltText; }
    return exports.open(options);
  };

  // Compatibility exports
  top.openIbox = openIbox;
  top.hideIbox = exports.close;

  // Export the earlier global variables (those assigned to top), if webpack is running
  if ((typeof module !== 'undefined' && module !== null ? module.exports : undefined) != null) {
    module.exports.openIbox = top.openIbox;
    module.exports.hideIbox = top.hideIbox;
    return module.exports.default_fancybox_options = top.default_fancybox_options;
  }
});

// Attach old ibox helpers
Slzr.jQuery(function($) {
  $('a[rel^="ibox"]').attr('onclick', null);
  $(document).on('click', 'a[rel^="ibox"]', function(evt) {
    const el = $(this);
    const parts = _.without(el.attr('rel').split(/^ibox[;\#]/), '');
    let url = null;
    for (const p of Array.from(parts[0].split(';'))) {
      if (p.indexOf('url=') === 0) {
        url = p.substr(4);
      }
    }

    openIbox(url, {
      element: this,
      event: evt
    }
    );

    evt.preventDefault();

    return false;
  });

  // data-action handler for showing a lightbox
  //
  // the lightbox (found with data-lightbox) should be specified
  // using a data-show-lightbox attribute on the element
  $(document).onAction('show-lightbox', function(evt) {
    const $el = $(this);
    const lightbox = $el.data('show-lightbox');

    const lightbox_element = $(`[data-lightbox=\"${lightbox}\"]`).uniqueId();

    if (lightbox_element.length === 1) {
      const lightbox_url = `#${lightbox_element.attr('id')}`;
      return openIbox(lightbox_url, {element: this, event: evt});
    } 
      return (typeof console !== 'undefined' && console !== null ? console.error(`Lightbox not found: ${  lightbox}`) : undefined);
    
  });


  // Show survey dialog, and set cookie
  // Only show the survey lightbox if the container is in dom
  if ($('#x-survey-lightbox').length > 0) {
    const SURVEY_VERSION = '2';
    if (Cookies.get('seen_survey') !== SURVEY_VERSION) {
      Cookies.set('seen_survey', SURVEY_VERSION, {path: '/', expires: 45}); // days
      openIbox('#x-survey-lightbox');
    }
  }

  // Show admin survey dialog, and set cookie
  // Only show the survey lightbox if the container is in dom
  if ($('#x-admin-survey-lightbox').length > 0) {
    const ADMIN_SURVEY_VERSION = '2';
    if (Cookies.get('seen_admin_survey') !== ADMIN_SURVEY_VERSION) {
      Cookies.set('seen_admin_survey', ADMIN_SURVEY_VERSION, {path: '/', expires: 45}); // days
      return openIbox('#x-admin-survey-lightbox');
    }
  }
});


function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}